import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.awards-slider' ).length ) {
        $( '.awards-slider' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'fade',
            gap: '2rem',
            perPage: 1,
            pagination: false,
            perMove: 1,
            speed: 800,
          } );

          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                focus: 0,
              };
            }
          } );

          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'awards-slider', COMPONENT );
} )( app );
